module.exports = __webpack_public_path__ + "img/Thermo Gun.53f04277.png";